'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _editController = require('./edit.controller');

var _editController2 = _interopRequireDefault(_editController);

var _editHtml = require('./edit.html');

var _editHtml2 = _interopRequireDefault(_editHtml);

function RouteConfig($stateProvider) {
	'ngInject';

	$stateProvider.state('app.private.tickets.edit', {
		controller: _editController2['default'],
		template: _editHtml2['default'],
		'url': '/edit?seatId&subLineId&busId&date',
		'controllerAs': 'vm',
		'resolve': {
			'Discounts': function Discounts(DiscountComponent) {
				'ngInject';

				return DiscountComponent.fetchDiscounts();
			},
			'Currencies': function Currencies(CurrencyComponent) {
				'ngInject';

				return CurrencyComponent.fetchCurrencies();
			},
			'Seat': function Seat($filter, $state, $stateParams, SubLineComponent, TicketComponent, Toast) {
				return TicketComponent.fetchSeat($stateParams.seatId).then(function (res) {
					if (res.data && res.data.errors) {
						Toast.responseError(res.data.errors);
						$state.go('app.private.tickets.chooseSubLine');
					} else {
						var params = undefined;
						if ($stateParams.subLineId && $stateParams.busId && $stateParams.date) {
							params = {
								'subLineId': $stateParams.subLineId,
								'busId': $stateParams.busId,
								'date': $stateParams.date
							};
						} else {
							params = {
								'subLineId': res.sub_line_id,
								'busId': res.bus_id,
								'date': $filter('dateParser')(res.departs_at, 'YYYY-MM-DD')
							};
						}

						return SubLineComponent.fetchSubLine(params.subLineId, params.busId, params.date).then(function (response) {
							if (response.data && response.data.errors) {
								Toast.responseError(response.data.errors);
								$state.go('app.private.tickets.chooseSubLine');
							} else {
								res.sub_line = response;

								return res;
							}
						});
					}
				});
			}
		}
	});
}

exports['default'] = RouteConfig;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/tickets/edit/edit.route.js
 **/